<template>  
  <div class="warning">
    <div class="header"></div>
    <img src='https://img.stem.cn/online/to_join/content.jpg' alt=''>
  </div>
</template>
<script>
  //单独引入消息提示
  import { Message } from 'element-ui';

export default {
  data(){
      return {
        
      }
  },
  methods: {
    
   
   
  },
  created(){
  
  }    
}   
</script>
<style lang="scss">
  .warning {
    text-align: center;
      .header {
        height: 548px;
        background: url('https://img.stem.cn/online/to_join/2.jpg') no-repeat center;
        background-size: cover;
      }

  }

</style>
